import Layout from './layout/layout.js';
import * as Routes from './routes/index.js';

const Template = () => <Layout routes={Routes} />;

export default Template;
